export enum ArticlesPath {
  ID_ARTICLE_PARAM_MAP = 'idArticle',
  LISTE = '',
  EDITION = 'edition-article',
  EDITION_GENERAL = 'general',
  CREATION = 'creation-article',
}
